import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#2d4198', // A
          'primary-darken1': '#2d3661', // R
          'primary-lighten1': '#dde9ff', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#F9C618', // B
          'secondary-darken1': '#dbb942', // D
          secondaryBtnText: '#424242', // B'
          headerBack: '#2d4198', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#FFFFFF', // H
          topSecondaryBtn: '#F9C618', // I
          topSecondaryBtnText: '#424242', // J
          topPrimaryBtn: '#2d4198', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#2d4198', // N
          secondaryOutLineBtnText: '#424242', // O
          topBtnUpTextSp: '#FFFFFF', // P
          topBtnBackSp: '#0C184D', // Q'
          eventHeaderBack: '#F9C618',
          eventHeaderText: '#2d4198',
          eventTopBorderSub: '#F9C618',
          accent: '#2d4198', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
